import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TextField, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { IReportForm } from "reports/model"
import { setReportsParameters } from "reports/tools/common"
import { getReportForm } from "reports/tools/ui"
import { FlexBox } from "ui/components/FlexBox"

interface IReportInfosProps {
  form: IReportForm
}

const ReportInfosFn = React.memo(({ form }: IReportInfosProps) => {
  const {
    isUpdating,
    parameters: { name, description },
    updateFormError
  } = form
  return (
    <FlexBox ai="start" jc="start" vertical fullWidth gap>
      <FlexBox fullWidth vertical gap=".5rem" ai="start">
        <Typography color="textPrimary" fontSize=".9rem">
          {translate("label.name")}
        </Typography>
        <TextField
          id="reports-name-field"
          size="small"
          value={name}
          required
          disabled={isUpdating}
          fullWidth
          onChange={event => setReportsParameters(false, { name: event.target.value })}
        />
      </FlexBox>
      <FlexBox fullWidth vertical gap=".5rem" ai="start" sx={{ "& > *": { width: "100%" } }}>
        <Typography color="textPrimary" fontSize=".9rem">
          {translate("label.description")}
        </Typography>
        <TextField
          id="reports-description-field"
          size="small"
          value={description}
          multiline
          minRows={2}
          maxRows={2}
          required
          disabled={isUpdating}
          fullWidth
          placeholder={translate("reports.description.add")}
          onChange={event => setReportsParameters(false, { description: event.target.value })}
        />
      </FlexBox>
      {updateFormError && (
        <FlexBox fullWidth gap jc="end" sx={{ "& .icon": { color: theme => theme.palette.error.main } }}>
          <FontAwesomeIcon icon={faTriangleExclamation} size="2x" className="icon" />
          <Typography color="error" fontSize=".9rem">
            {updateFormError}
          </Typography>
        </FlexBox>
      )}
    </FlexBox>
  )
})

export const ReportInfos = connect((state: IRootState): IReportInfosProps => {
  const form = getReportForm(false, state.reports)
  return {
    form
  }
})(ReportInfosFn)
